require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-zero-95-is-coming-to-the-bend.json") })
        }
      }, "path---news-zero-95-is-coming-to-the-bend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-zero-95-is-coming-to-the-bend!./.cache/json/news-zero-95-is-coming-to-the-bend.json
// module id = 878
// module chunks = 231608221292675